import { render, staticRenderFns } from "./ArrowStep.vue?vue&type=template&id=2efe0a56&scoped=true"
var script = {}
import style0 from "./ArrowStep.vue?vue&type=style&index=0&id=2efe0a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe0a56",
  null
  
)

export default component.exports